import React from "react";

import Index1 from "./pages/Index1/Index1";
import Index2 from "./pages/Index2/Index2";
import Index3 from "./pages/Index3/Index3";
import Index4 from "./pages/Index4/Index4";
import Index5 from "./pages/Index5/Index5";
import Index6 from "./pages/Index6/Index6";
import Index7 from "./pages/Index7/Index7";
import Index8 from "./pages/Index8/Index8";
import Index9 from "./pages/Index9/Index9";
import Index10 from "./pages/Index10/Index10";
import Features from "./pages/Features/Features";
import SwitchFromCanny from "./pages/SwitchFromCanny/SwitchFromCanny";

//Auth Pages
import Signup from "./pages/Auth/Signup";
import Login from "./pages/Auth/Login";
import PasswordForget from "./pages/Auth/PasswordForget";

//Legal Pages
import TermsOfService from "./pages/Legal/TermsOfService";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import Faq from "./pages/Legal/Faq";

const routes = [
  { path: "/terms-of-service", component: <TermsOfService /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/faq", component: <Faq /> },
  { path: "/password-forget", component: <PasswordForget /> },
  { path: "/login", component: <Login /> },
  { path: "/sign-up", component: <Signup /> },

  { path: "/features", component: <Features /> },
  { path: "/switch-from-canny", component: <SwitchFromCanny /> },
  { path: "/home-ten", component: <Index10 /> },
  { path: "/home-nine", component: <Index9 /> },
  { path: "/home-eight", component: <Index8 /> },
  { path: "/home-seven", component: <Index7 /> },
  { path: "/home-six", component: <Index6 /> },
  { path: "/home-five", component: <Index5 /> },
  { path: "/home-four", component: <Index4 /> },
  { path: "/home-three", component: <Index3 /> },
  { path: "/home-two", component: <Index2 /> },
  { path: "/home-one", component: <Index1 /> },
  { path: "/", component: <Index10 /> },
];

export default routes;
